import Config from '@shared/config/constants/config-main';
import styles from '@features/b2b-contact-form/styles/MainB2BLayout.module.css';
import React from 'react';

import { useLanguage } from '@entities/language/model/hooks/useLanguage';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { VideoBanner } from '@features/b2b-contact-form/ui/VideoBanner';
import { B2BForm } from '@features/b2b-contact-form/ui/B2BForm';

export const MainB2BLayout: React.FC = () => {
  useLanguage();

  return (
    <div className={styles.mainLayout} dir={'ltr'}>
      <VideoBanner />

      <GoogleReCaptchaProvider reCaptchaKey={Config.RE_CAPTCHA_KEY}>
        <B2BForm />
      </GoogleReCaptchaProvider>
    </div>
  );
};
